
import * as marietta from '../../../marietta';
import * as marietta3d from "../../../marietta3d";
import { defines } from '../base';
import { ModelInfo, View3dGlobal, webcadDefines } from './index';

import * as THREE from 'three';
import { ThreeView } from '../../../marietta/view3d/webcad';
import { WebCADGlobal } from '../../webcad';
import * as ModelLoader from './loader';

import { BUILDING_TYPE_MANSION } from '../../webcad/Constants';
import { WizardTool } from '../../webcad/view/dialog/WizardLiDAR/WizardTool';
import { OctreeManager } from './Octree/OctreeManager';
import { SelectManager } from './SelectManager';
import { HDREnvironment } from "./View3dWebCadEnviron";
import { CameraPinLoader } from './loader/AddCameraPin';
import { AddPin, pinData } from './loader/AddPin';
import { optChangeWizardMode, optAutoIntersectMode, Option3D, optWizardMode } from './util/Option3DInterface';

type USerData = { [key: string]: any };
export class ModelLoadSystem {

    private option3D: Option3D = null;

    private serverApi: marietta3d.manager.ApiRequest;

    /**
     * 3Dリクエスト
     */
    public request3D() {
        console.log('3Dリクエスト中');
        WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_REQUESTING_3D'), this.executeRequest3D);
    }

    private setPlanParam = (userData: USerData) => {
        const aData: marietta3d.AutoGen.AutoBase = WebCADGlobal.autoMain.autoData;
        const plan_size = userData.plan_size;
        aData.planSizeX = plan_size && plan_size[0] > 0 ? plan_size[0] : 0;
        aData.planSizeY = plan_size && plan_size[1] > 0 ? plan_size[1] : 0;

        // レスポンスにいない plan_high_param message TODO
        // const phigh = contr[0].getElementsByTagName('plan_high_param');
        // aData.Model.readHeightXML(phigh);
        // const message = contr[0].getElementsByTagName('message');
        // if (message.length > 0) {
        //     ermsg = message[0].textContent;
        //     ermsg = ermsg.replace(/\n/g, '<br>');
        // }
    }

    private printUserData (node) {
        console.log(`userData: ${ JSON.stringify(node.userData)}` );
    }
    private printGraph (node) {
        console.group(' <' + node.type + '> ' + node.name);
        this.printUserData(node);
        node.children.forEach((child) => this.printGraph(child));
        console.groupEnd();
    }

    /**
     * 3Dリクエスト実行
    */
    private executeRequest3D = () => {
        const autoMain = WebCADGlobal.autoMain;
        autoMain.culcScale(100, 100); // 3D座標への変換のため。（100,100はダミー）
        this.serverApi = new marietta3d.manager.ApiRequest(autoMain.autoData);
        const itemmanager = this.getItemManager();

        const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        const aData: marietta3d.AutoGen.AutoBase = this.webcadGlobal().autoMain.autoData;
        aData.InitDimensionList(); // 初期化
        // リクエストの結果、戻ってきたGLBデーターの処理
        const success = (bufferData: ArrayBuffer) => {

            new ModelLoader.GLTFHouseLoader().loadAsync(bufferData).then((glb) => {
                // @ts-ignore
                const data = glb.scene;
                const userData = data.userData;
                if (userData.itemLib == null) {
                    userData.itemLib = [];
                }
                itemmanager.GltfExtras = userData;

                // this.printGraph(data);

                // 頂点の法線情報が正しくないので自前で生成する
                data.traverse((obj: THREE.Object3D) => {
                    //@ts-ignore
                    if (obj.isMesh == null) return;
                    (<THREE.Mesh>obj).geometry.computeVertexNormals();
                })

                // プランパラメータ―をセット
                this.setPlanParam(userData);

                // 寸法線データ登録
                this.dimension(userData);

                this.setupDispatcher();
                return data;
            }).then((data: THREE.Group) => {
                let ermsg: string = '';
                this.start3D(data, ermsg);

                this.setupUI();
            }).catch((e) => {

                console.log(e);
                debugger;

                let error = webcadDefines.WebCadMessageDefs.miscError;

                // エラーを表示して、操作モードに.
                this.ThreeView().showMessage(webcadDefines.WebCadMessageDefs.creationFailure, error);
                this.getCameras().doTween(this.getCameras().fadeIn);
                this.ThreeView().exitToNormal();
            });

        }
        const unsuccess = (msg: string) => {
            if (msg.indexOf('ただいま大変混み合っております') >= 0) {
                this.webcadGlobal().showAlertForRequest3DTimeOut();
            } else {
                const DimAry = [];
                DimAry.push([]);
                DimAry.push([]);
                DimAry.push([]);
                this.setupDispatcher();
                this.start3D(null, msg);
                this.setupUI();
            }
        };

        // 読み込みクロージャを引数に指定してASPへのリクエスト
        this.APIRequest('api/model_3d', reqJson, success, unsuccess);
    }

    // サーバーリクエストによるGLBデーター取得
    private APIRequest(IISName: string, requestJson: string, success: Function, unsuccess: Function) {
        const url = WebCADGlobal.autoMain.autoData.apiUrlPath;
        const controller = new AbortController();
        const timeout_ = setTimeout(() => { controller.abort(), 30000 });
        const itemmanager = this.getItemManager();
        fetch(`${url + IISName}`, {
            method: 'POST',
            headers: {
                'Content-Type' : 'application/json'
            },
            body: requestJson
        }).then((response) => {
            if (!response.ok) {
                console.error('サーバーエラー');
            }
            if (response.status >= 200 && response.status <= 299) {
                return response.arrayBuffer();
            }
            // ここに成功時の処理を記述
        }).then((buffer) => {
            itemmanager.BinaryData = buffer;
            success(buffer);
        })
        .catch(error => {
            console.error('通信に失敗しました', error);
        })
        .finally(() => {
            clearTimeout(timeout_);
        });
    }

    // 寸法線データーの取得
    private dimensionData(userData: any): marietta3d.AutoGen.object.AutoObjDimension[][] {
        const DimAry: marietta3d.AutoGen.object.AutoObjDimension[][] = [];
        const scale: marietta3d.AutoGen.Scale = this.scaleObject();
        const dimension = userData.plan_dimension;
        DimAry.push([]);
        DimAry.push([]);
        DimAry.push([]);
        for (let floor = 1; floor <= dimension.length; floor += 1) {
            const sunpou =  dimension[floor - 1].item;
            if (sunpou == null) return DimAry;
            for (let i = 0; i < sunpou.length; i += 1) {
                const points = sunpou[i].point;
                const p1_ = new marietta.core.Point(points[2], points[3]);
                const p2_ = new marietta.core.Point(points[4], points[5]);
                const p1w_ = new marietta.core.Point(points[0], points[1]);
                const p2w_ = new marietta.core.Point(points[6], points[7]);
                // const p1_ = new marietta.core.Point(sunpou[i].dim_line.start.x, sunpou[i].dim_line.start.y);
                // const p2_ = new marietta.core.Point(sunpou[i].dim_line.end.x, sunpou[i].dim_line.end.y);
                // const p1w_ = new marietta.core.Point(sunpou[i].pre.start.x, sunpou[i].pre.start.y);
                // const p2w_ = new marietta.core.Point(sunpou[i].post.end.x, sunpou[i].post.end.y);
                const p1 = scale.ConvertTo3DModelFromWebCAD(p1_);
                const p2 = scale.ConvertTo3DModelFromWebCAD(p2_);
                const p1w = scale.ConvertTo3DModelFromWebCAD(p1w_);
                const p2w = scale.ConvertTo3DModelFromWebCAD(p2w_);
                const wdim = new marietta3d.AutoGen.object.AutoObjDimension(floor, p1, p2, p1w, p2w, sunpou[i].text);
                DimAry[floor - 1].push(wdim);
            }
        }
        return DimAry;
    }

    // 寸法線データ登録
    private dimension(userData: USerData) {
        const dimension = userData.plan_dimension;
        if (dimension.length <= 0) return;

        const aData: marietta3d.AutoGen.AutoBase = WebCADGlobal.autoMain.autoData;
        const sc: marietta3d.AutoGen.Scale = this.scaleObject();

        // Dim 読み込み
        aData.perseDimension_(dimension, sc);
    }

    private setupDispatcher() {
        WebCADGlobal.hideBusy();

        // 3Dモデルの構築が終わった時.
        const fin3dsetup = (): void => {
            WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_DOWNLOAD_MATERIAL'));
        }

        const finTexload = (): void => WebCADGlobal.hideBusy();         // テクスチャのロードが終わった時.
        const fin3Dload = (): void => WebCADGlobal.hideBusyStrict();    // 3Dモデルのロードが終わった時.

        // 失敗
        const fail3dsetup = (): void => {
            this.webcadGlobal().hideBusy();
            this.webcadGlobal().showAlert('ネットワーク環境に問題があるため、ネットワーク環境が良い場所から再度リトライしてください');
        }

        // 古いイベントリスナーを削除.
        if (View3dGlobal.shared.eventDispatcher.listeners.fin3dsetup) View3dGlobal.shared.eventDispatcher.removeEventListener(webcadDefines.WebCadEventNames.setup3DFinished, fin3dsetup);
        if (View3dGlobal.shared.eventDispatcher.listeners.finTexload) View3dGlobal.shared.eventDispatcher.removeEventListener(webcadDefines.WebCadEventNames.loadingTexFinished, finTexload);
        if (View3dGlobal.shared.eventDispatcher.listeners.fin3Dload) View3dGlobal.shared.eventDispatcher.removeEventListener(webcadDefines.WebCadEventNames.loadingModelFinished, fin3Dload);

        // 3Dモデルの構築が終わった時.
        View3dGlobal.shared.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.setup3DFinished, fin3dsetup);
        // テクスチャのロードが終わった時.
        View3dGlobal.shared.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.loadingTexFinished, finTexload);
        // 3Dモデルのロードが終わった時.
        View3dGlobal.shared.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.loadingModelFinished, fin3Dload);
    }

    private webcadGlobal() {
        return marietta.webcad.WebCADGlobal;
    }

    private setupUI () {
        // 3Dのボタンの表示をデフォルトに戻す
        marietta.webcad.WebCADGlobal.init3dMenu();
        (document.querySelectorAll('.for2D')).forEach((_elem: HTMLElement) => {
            const elem = _elem;
            elem.style.display = 'none';
        });
        (document.querySelectorAll('.for3D')).forEach((_elem: HTMLElement) => {
            if (_elem.id == 'btnMesureParent') {
                return;
            }
            const elem = _elem;
            elem.style.display = 'block';
        });

        const PSS = document.getElementById('pixelStreamingStatus');
        if(PSS) {
            PSS.style.display = 'none';
            const container = document.getElementById('streamingLogContainer');
            if (container) {
                container.innerHTML = '';
            }
        }

        (document.querySelector('#developMenus3D')).querySelectorAll('input').forEach((_elem) => {
            const elem = _elem;
            elem.style.display = 'inline-block';
        });

        // 3D 左メニュー初期化
        this.webcadGlobal().itemChangeMenuCategories3d.reset();
        this.webcadGlobal().changeHeightMenu.init();
        this.webcadGlobal().roofColorMenu.init();
        this.webcadGlobal().roofShapeMenu.init();
        this.webcadGlobal().outColorMenu.init();
        this.webcadGlobal().sashColorMenu.init();
        this.webcadGlobal().innerColorMenu.init();
        this.webcadGlobal().designOptionMenu.init();
        this.webcadGlobal().innerDesignOptionMenu.init();

        if (this.webcadGlobal().webcad2Dmanager.mode === '2') {
            // 参照モードへ
            document.getElementById('itemMenuWrap').style.display = 'none';
            document.getElementById('headerMenu2D').style.display = 'none';
            document.getElementById('itemControlPanel').style.display = 'none';
            document.getElementById('itemChangeMenuWrap').style.display = 'none';
        }
        this.webcadGlobal().dimensionMenu.mode = '3D';
        marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode();
    }

    private ThreeView() {
        return ThreeView.get();
    }

    private getItemManager() {
        return ThreeView.get().wcItemmgr;
    }

    private getScene() {
        return ThreeView.get().wcScene;
    }

    private getCameras() {
        return ThreeView.get().wcCameras;
    }

    private getAutoMain() {
        return ThreeView.get().planmgr;
    }

    private getSunpou() {
        return ThreeView.get().wcSunpou;
    }

    private scaleObject(): marietta3d.AutoGen.Scale {
        return this.webcadGlobal().autoMain.autoData.scaleObj;
    }

    // private setupEnviroment() {

    //     const environment = new HDREnvironment();
    //     environment.reset(this.getScene());

    //     const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/mud_road_puresky_1k.hdr`;
    //     environment.apply(ThreeView.get().wcScene, url);

    //     const renderer = ThreeView.get().wcRenderer._instance;
    //     renderer.toneMapping = THREE.ACESFilmicToneMapping;
    //     renderer.toneMappingExposure = 1.3;

    //     // const changeHDRE = (path: string) => {
    //     //     environment.apply(ThreeView.get().wcScene, path);
    //     // }
        
    //     //マンションモード時の構築
    //     // if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
    //     //     // changeHDRE(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/sunset_jhbcentral_1k.hdr`);
    //     //     // changeHDRE('./assets/3d/item/test_item/sunset_jhbcentral_1k.hdr');
    //     // } else {
    //     //     // changeHDRE(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/mud_road_puresky_1k.hdr`);
    //     //     // changeHDRE('./assets/texture3d/mud_road_puresky_1k.hdr');

    //     //     const renderer = ThreeView.get().wcRenderer._instance;
    //     //     renderer.toneMapping = THREE.ACESFilmicToneMapping;
    //     //     // renderer.toneMapping = THREE.CineonToneMapping;
    //     //     renderer.toneMappingExposure = 1.3;
    //     // }
    // }

        private setupEnviroment() {
        const environment = new HDREnvironment();
        environment.reset(this.getScene());

        const changeHDRE = (path: string) => {
            environment.apply(ThreeView.get().wcScene, path);
        }

        const cloudImage = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}/texture3d/unfinished_office_1k.hdr`;

        //マンションモード時の構築
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
            // const sunsetImage = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/sunset_jhbcentral_1k.hdr`;
            // const cloudImage = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/brown_photostudio_02_1k.hdr`;
            // const cloudImage = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/mud_road_puresky_1k.hdr`;
            // changeHDRE(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/sunset_jhbcentral_1k.hdr`);
            // environment.applyBackground(ThreeView.get().wcScene, sunsetImage);
            environment.applyEnviroment(ThreeView.get().wcScene, cloudImage);

            const renderer = ThreeView.get().wcRenderer._instance;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            // renderer.toneMapping = THREE.CineonToneMapping;
            renderer.toneMappingExposure = 0.8;
            // changeHDRE('./assets/3d/item/test_item/sunset_jhbcentral_1k.hdr');
        } else {
            // changeHDRE(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/mud_road_puresky_1k.hdr`);
            // const cloudImage = './assets/texture3d/unfinished_office_1k.hdr';
            environment.applyEnviroment(ThreeView.get().wcScene, cloudImage);
            // changeHDRE('./assets/texture3d/mud_road_puresky_1k.hdr');

            const renderer = ThreeView.get().wcRenderer._instance;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            // renderer.toneMapping = THREE.CineonToneMapping;
            renderer.toneMappingExposure = 1.0;
        }
    }

    /**
     * 3D描画開始
     */
    private start3D = (glb: THREE.Group, error: string) => {
        this.ThreeView().opeMode = defines.OpeMode.create;     // 生成モードに.
        this.ThreeView().resetScene();                         // クリーンアップ.
        // if (this.environment != null) this.environment.reset(this.getScene()); // 環境光をリセット
        this.setupEnviroment();

        if (this.show3D(glb, error)) {
            this.webcadGlobal().showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_DOWNLOAD_MODEL'));
        } // 'fix3Dload'で回収する.
    }

    /* show3D
     * 3D表示要求.
     */
    private show3D(glb: THREE.Group, error: string): boolean {
        let result = true;
        const threeView = this.ThreeView();
        const cameras = this.getCameras();
        try {
            this.getItemManager().registSetBack(glb);      // 斜線形状の登録
            this.getItemManager().setHouseObjects(glb);

            // マテリアルのセットアップ
            this.ThreeView().matmgr.setupMaterials(this.getAutoMain());

            result = this.processData(glb.userData);

            // メニューの調整
            threeView.menus.adjustMenus(webcadDefines.WebCadEventNames.reset3DView);

            // メッセージがあれば表示.
            threeView.getShowMessage();
        } catch (Error) {
            // エラーを表示して、操作モードに.
            threeView.showMessage(webcadDefines.WebCadMessageDefs.creationFailure, Error.message);
            cameras.doTween(cameras.fadeIn);
            threeView.exitToNormal();
        }
        return result;
    }


    /* initCameraStatus
     * Cameraのワープポイントなどを設定.
     */
    private initCameraStatus(): void {
        const itemmanager = this.getItemManager();
        const cameras = this.getCameras();
        const porch = itemmanager.warps.getFromName(webcadDefines.WarpPointNames.porch);
        const entre = itemmanager.warps.getFromName(webcadDefines.WarpPointNames.entrance);
        cameras.initCameraStatus(porch, entre);
    }

    /* setHouseMesures
     * 各フロアまでの高さを記録しておく等.
     */
    private setHouseMesures(userData: any, plan: marietta3d.AutoGen.AutoBase, xSize: number, ySize: number): void {
        const itemmanager = this.getItemManager();

        const unit = (value: number) => value / 1000.0;

        itemmanager.floorHeights.push((unit(Number(plan.Model.GetSlabLevel1()) + Number(plan.Model.GetFloor1()))));
        itemmanager.floorHeights.push((unit(Number(plan.Model.GetSlabLevel2()) + Number(plan.Model.GetFloor2()))));
        itemmanager.floorHeights.push((unit(Number(plan.Model.GetSlabLevel3()) + Number(plan.Model.GetFloor3()))));

        itemmanager.planHeight = userData.plan_high;

        itemmanager.xSize = unit(xSize);
        itemmanager.ySize = unit(ySize);
        itemmanager.updateHouseMesures();
    }

    /* processData
     * サーバーからのデータを処理して実体化.
     */
    private processData(userData: USerData): boolean {
        const itemmgr = this.getItemManager();
        // 成功ならデータを読み込む
        if (!this.checkStatus(userData)) {
            itemmgr.showMessage();
            this.webcadGlobal().hideBusy();
            ThreeView.get().cameras.no = 0;
            return false;
        }

        this.setupAssetInfo_GLB(userData);

        const aData: marietta3d.AutoGen.AutoBase = this.webcadGlobal().autoMain.autoData;
        const xSize = aData.planSizeX;
        const ySize = aData.planSizeY;

        this.setHouseMesures(userData, this.getAutoMain().autoData, xSize, ySize);

        const onload = () => {
            const automain = this.getAutoMain();
            const sunpou = this.getSunpou();
            // 寸法線の準備
            sunpou.setupSizeObjects(automain.autoData, xSize, ySize, this.dimensionData(userData));

            // ワープポイントの登録.
            this.WarpPointRegistration(userData);

            // カメラの設定.
            this.initCameraStatus();

            // 選択状態の管理
            ThreeView.get().selectManager = new SelectManager();

            // 家具・備品データの読込.
            new ModelLoader.FurnitureLoader().loadAsync()
                .then(() => {
                    this.furnituresLoaded();
                }).catch((message) => {
                    console.log(message);
                    debugger;
                    return Promise.resolve();
                }).then(() => {
                    this.startAnimation();
                });

            // 階段データの読込み.
            new ModelLoader.StairLoader().loadAsync();
            itemmgr.resetMapItems(); // TODO.   //

            // オブジェクトにマテリアルを適用.
            this.ThreeView().matmgr.applyMaterials(this.getItemManager());

            // ワンポイント壁対応
            this.ThreeView().matmgr.applyPointTexture(this.getItemManager());
        };

        //建具の読み込み.
        new ModelLoader.FittingLoader().loadAsync().then(() => {
            itemmgr.registHouse();
        }).then(() => {
            onload();
            return Promise.resolve();
        }).then(() => {
            this.setCameraPins().then(() => {
                this.buildScene();
                this.ThreeView().eventDispatcher.dispatchEvent(webcadDefines.WebCadEventNames.loadingModelFinished);

                if ((<optAutoIntersectMode>this.option3D)?.isAutoIntersectMode) {
                    new WizardTool().autoIntersectItem();
                }
                if ((<optWizardMode>this.option3D)?.isWizardMode && !(<optChangeWizardMode>this.option3D).isChangeMode) {
                    new WizardTool().wizardMode();
                }
            });
        }).then(() => {
            // this.buildScene();
            // this.ThreeView().eventDispatcher.dispatchEvent(webcadDefines.WebCadEventNames.loadingModelFinished);
        }).catch((message) => {
            console.log(message);
            debugger;
            return Promise.reject(new Error(message));
        });

        return true;
    }

    private checkStatus(userData: USerData) {
        return true;
    }

    private setupAssetInfo_GLB(userData: USerData) {
        const setData = (userData, type, sharedData) => {
            if (userData == null) return;
            Array.from(userData).forEach(element => {
                const info = new ModelInfo(type, element);
                sharedData.push(info);
            });
        }
        setData(userData.fitting, webcadDefines.PartType.fitting, View3dGlobal.shared.fitData);
        setData(userData.equipment, webcadDefines.PartType.equipment, View3dGlobal.shared.equData);
        setData(userData.furniture, webcadDefines.PartType.furniture, View3dGlobal.shared.furData);
        setData(userData.exterior, webcadDefines.PartType.exterior, View3dGlobal.shared.extData);
        setData(userData.stair, webcadDefines.PartType.stair, View3dGlobal.shared.staData);
        setData(userData.light, webcadDefines.PartType.light, View3dGlobal.shared.ligData);
        setData(userData.decoration, webcadDefines.PartType.decoration, View3dGlobal.shared.decData);

        ThreeView.get().matmgr.loadMaterialPrefs(userData);
    }

    /*
     * ワープポイントの登録
     */
    private WarpPointRegistration(userData: USerData): void {
        const itemmanager = this.getItemManager();
        marietta.view3d.webcad.WarpPoint.extractWarps(userData, itemmanager.warps);

        const DEBUG = false;
        if (DEBUG) {
            const n = itemmanager.warps.length;

            for ( let i = 0; i < n; i++) {
                const warp = itemmanager.warps.getFromIndex(i);

                const g = new THREE.Group();

                const pos = warp.position;
                {
                    const material = new THREE.LineBasicMaterial({ color: 0xff0000 });
                    const points = [];
                    points.push( pos.clone() );
                    points.push( pos.clone().add(new THREE.Vector3(0, 3, 0)) );
                    const geometry = new THREE.BufferGeometry().setFromPoints( points );
                    const line = new THREE.Line( geometry, material );
                    g.add(line);
                }
                {
                    const material = new THREE.LineBasicMaterial({ color: 0x00ff00 });
                    const points = [];
                    points.push( pos.clone() );
                    const dir = warp.lookAt.clone();
                    dir.normalize().multiplyScalar(0.6);
                    points.push( pos.clone().add(new THREE.Vector3(dir.x, 0, dir.y)) );
                    const geometry = new THREE.BufferGeometry().setFromPoints( points );
                    const line = new THREE.Line( geometry, material );
                    g.add(line);
                }
                itemmanager.addOtherShapes(g);
            }
        }
    }

    //2Dで設置したPinデーターで3DPin作成
    private setPins() {
        // テキストのピン
        const pins = marietta.webcad.WebCADGlobal.getPinTextItems();
        pins.forEach((pinData: pinData) => {
            const pin = new AddPin();
            pin.set(pinData);
        });
    }

    private async setCameraPins() {
        // CameraPin
        const picturePins = marietta.webcad.WebCADGlobal.getPinPictureItems();
        if (picturePins.length > 0) {
            await new CameraPinLoader().load(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}3d/item/cameraPin.glb`, picturePins);
        };
    }

    /* furnituresLoaded
    * 家具・備品情報の読込後の処理.
    */
    private furnituresLoaded(): void {
        // furnitureObjectsにストックマテリアルを適用.
        ThreeView.get().matmgr.adjustMaterials(ThreeView.get().wcItemmgr.furnitureObjects);

        ThreeView.get().wcItemmgr.setupBillBoards();        // billboardの登録

        if (ThreeView.get().wcCameras.opeMode != defines.OpeMode.animate) { ThreeView.get().opeMode = defines.OpeMode.operate; }

        // アイテム選択
        ThreeView.get().setupModelSelect();

         // 部屋の部位選択
        ThreeView.get().RoomSelector();

        // データ構造の作成
        // console.profile('create tree test');
        ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
        // console.profileEnd('create tree test');

        // 画角内判定
        ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

        // pinデーターの構築
        this.setPins();
    }

    private startAnimation = (): void => {
        // ロードとデータのセットアップが完了(同期分)したことを知らせる.
        ThreeView.get().wcItemmgr.eventDispatcher.dispatchEvent(webcadDefines.WebCadEventNames.setup3DFinished);

        // カメラを切り替えてFadeIn アニメーションが開始する.
        if (ThreeView.get().wcItemmgr.textureLoadingCount <= 0) {
            // load at least one texture image.
            const url: string = `${this.webcadGlobal().webcad2Dmanager.assets_url}texture3d/default.png`;
            ThreeView.get().wcItemmgr.startLoadingTexture(url);

            THREE.ImageUtils.crossOrigin = '*';
            const texLoader = new THREE.TextureLoader();
            texLoader.crossOrigin = '*';
            const texture: THREE.Texture = texLoader.load(url, (texture) => {
                ThreeView.get().wcItemmgr.endLoadingTexture(url, this.option3D);
            }, (err) => {
                ThreeView.get().wcItemmgr.errorLoadingTexture(marietta.webcad.collection.WebCADMessages.INFO_REGISTER_COMPLETE_JP);
            });

            marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();    // 見積りのリスト更新
        }
    }

    /* buildScene
     * シーンの構築.
     */
    private buildScene(): void {
        const addScene = objects => {
            if (objects) scene.add(objects);
        }

        const itemmanager = this.getItemManager();
        const scene: THREE.Scene = this.getScene().me;
        if (itemmanager.houseObjects != undefined) {
            itemmanager.houseObjects.name = '建物、設備、建具類';
            scene.add(itemmanager.houseObjects);
        }
        if (itemmanager.sizesObjects != undefined) {
            const group = new THREE.Group();
            group.name = "寸法線";
            for (const key in itemmanager.sizesObjects.objects) {
                const sizes = itemmanager.sizesObjects.getObjects(key);
                for (let i = 0; i < sizes.length; i++) {
                    group.add(sizes[i]);
                }
            }
            addScene(group);
        }
        addScene(itemmanager.lightTargets);

        if (itemmanager.OtherShapes == null) {
            itemmanager.addOtherShapes(new THREE.Group());
        }
        addScene(itemmanager.OtherShapes);

        if (itemmanager.AddItemShapes == null) {
            itemmanager.addItemShapes(new THREE.Group());
        }
        addScene(itemmanager.AddItemShapes);

        if (itemmanager.LiDARShapes == null) {
            itemmanager.addLiDARShapes(new THREE.Group());
        }
        addScene(itemmanager.LiDARShapes);

        // 環境光追加
        // this.environment = new HDREnvironment();
        // this.environment.applyScene(this.getScene(), new RoomEnvironment());

        // const ground = (flag: boolean) => {
        //     const scene = this.getScene().me;
        //     const obj = scene.getObjectByName(defines.DefNames.terrain);
        //     obj.visible = flag;
        //     const grid = scene.getObjectByName("グリッド線");
        //     grid.visible = flag;
        // }

        //マンションモード時の構築
        // ground(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType !== BUILDING_TYPE_MANSION);

        //
        const MANSION_MODE = true;
        if (MANSION_MODE) {
            // let sky: Sky;

            const visible = (obj: THREE.Object3D, flag: boolean) => {
                if (obj) {
                    obj.visible = flag;
                }
            }
            visible(ThreeView.get().wcScene.me.getObjectByName(defines.DefNames.terrain), !(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION));
            visible(ThreeView.get().wcScene.me.getObjectByName('グリッド線'), !(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION));
            // visible(ThreeView.get().wcScene.me.getObjectByName('空'), !(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION));
            // visible(ThreeView.get().wcScene.me.getObjectByName('雲'), !(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION));

            // const environment = new HDREnvironment();
            // environment.reset(ThreeView.get().wcScene);

            // const changeHDRE = (path: string) => {
            //     environment.apply(ThreeView.get().wcScene, path);
            // }

            //マンションモード時の構築
            if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {

                // changeHDRE(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/sunset_jhbcentral_1k.hdr`);
                // changeHDRE('./assets/3d/item/test_item/sunset_jhbcentral_1k.hdr');

                ThreeView.get().wcItemmgr.outerLine = null;
                // 外周線があったら
                if (ThreeView.get().wcItemmgr.GltfExtras && ThreeView.get().wcItemmgr.GltfExtras.first_floor_outline) {
                    const points = ThreeView.get().wcItemmgr.GltfExtras.first_floor_outline;
                    ThreeView.get().wcItemmgr.outerLine = this.createOuterLine(points);
                    // this.createShell(points, 0, -30, true);
                    this.createShell(points, 10, 0, false);
                }
            } 
            // else {
    
            //     // changeHDRE(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture3d/mud_road_puresky_1k.hdr`);
            //     // changeHDRE('./assets/texture3d/mud_road_puresky_1k.hdr');
    
            //     // const renderer = ThreeView.get().wcRenderer._instance;
            //     // renderer.toneMapping = THREE.ACESFilmicToneMapping;
            //     // // renderer.toneMapping = THREE.CineonToneMapping;
            //     // renderer.toneMappingExposure = 1.3;
            // }

            // 各光源の強度を０設定
            // HDRで環境光をセットしているので、光量が増えて白飛びするのを防止
            ThreeView.get().wcScene.me.traverse((obj) => {

                const light = <THREE.Light>obj;
                if (light.isLight) {
                    light.intensity = 0;
                }
            })

            // R2Mレンダリング要求ボタンの設定
            // ThreeView.get().r2mButtonSetting.execute();
        }

    }

    // Loft Tool
    // isloopはpoints1,points2がループしている時にtrueとする事で筒状の形状を作成する
    // falseの場合、pointsの末端が先頭と繋がらない為、Cのような連続しない壁となる
    private loftGeometry(points1: THREE.Vector3[], points2: THREE.Vector3[], isloop?: boolean): THREE.BufferGeometry {
        const pointdata: THREE.Vector3[] = [...points1, ...points2];

        const num = isloop ? 0 : 1;

        // Float32Arrayをバッファとして各頂点を収納する（x,y,z,x,y,z,x,y,z....の順
        // 三角の３頂点 * 三角２つで四角  * 面の数
        const vBuffer = new vertexBuffer(3 * 2 * (points1.length - num));

        // 引数isloopが真ならpoints1の末端はループとして処理

        for (let i = 0; i < points1.length - num; i++) {
            const p1 = pointdata[i];
            const p2 = pointdata[(i + 1) % points1.length];
            const p3 = pointdata[points1.length + i];
            const p4 = pointdata[points1.length + ((i + 1) % points1.length)];
            vBuffer.set(p1);
            vBuffer.set(p2);
            vBuffer.set(p3);

            vBuffer.set(p2);
            vBuffer.set(p4);
            vBuffer.set(p3);
        }

        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.BufferAttribute(vBuffer.buffer(), 3));
        geometry.computeVertexNormals();
        geometry.computeBoundingBox();
        return geometry;
    }

    private createOuterLine(points: number[]): THREE.Vector2[] {
        const result: THREE.Vector2[] = [];
        for ( let i = 0; i < points.length; i+= 2) {
            result.push( new THREE.Vector2( points[i], points[i + 1] * -1) );
        }
        return result;
    }

    private createShell(points: number[], top: number, bottom: number, visible: boolean) {
        const material = new THREE.MeshStandardMaterial({
            opacity: 1.0,
            color: 0x696969,
            // depthTest: false,
            // depthWrite: false,
            side: THREE.DoubleSide,
            transparent: true
        });
        material.name = 'virtualWall';      // 当たり判定用の壁

        const group = new THREE.Group();
        group.name = "外周";

        const points3dTop: THREE.Vector3[] = [];
        const points3dbottom: THREE.Vector3[] = [];

        for ( let i = 0; i < points.length; i+= 2) {
            points3dTop.push( new THREE.Vector3( points[i], top, points[i + 1] * -1) );
            points3dbottom.push( new THREE.Vector3( points[i], bottom, points[i + 1] * -1) );
        }

        const geometry = this.loftGeometry(points3dTop, points3dbottom, true);

        const mesh = new THREE.Mesh(geometry, material);
        mesh.userData.wall = true;
        mesh.name = 'wall';
        mesh.renderOrder = -1;
        mesh.visible = visible;
        group.add(mesh);

        ThreeView.get().wcItemmgr.addOtherShapes(group);
        ThreeView.get().wcItemmgr.registObjects(group); //当たり判定用に登録
    }

    public setOption(option: Option3D): void {
        this.option3D = option;
    }
}

abstract class buffer {

    protected buffer_: Float32Array;
    protected count: number;
    protected errorMessage: string;

    constructor(num, dim) {
        this.buffer_ = new Float32Array(num * dim);
        this.count = 0;
    }

    protected set_(nums: number[]) {
        if (this.buffer_.length <= this.count) {
            console.warn(this.errorMessage);
            return;
        }

        for (let i = 0; i < nums.length; i++) {
            this.buffer_[this.count + i] = nums[i];
        }

        this.count = this.count + nums.length;
    }

    public buffer() {
        return this.buffer_;
    }
}
export class vertexBuffer extends buffer {

    constructor(num) {
        super(num, 3);
    }

    public set(p: THREE.Vector3) {
        // this.errorMessage = 'vertexBuffer.set: error!';
        // if (p.x == NaN || p.y == NaN || p.z == NaN) {
        //     console.error('Vertex Error NAN');
        // }

        this.set_([p.x, p.y, p.z]);
    }

    public setArray(points: THREE.Vector3[]) {
        // this.errorMessage = 'vertexBuffer.setArray: error!';
        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            this.set_([p.x, p.y, p.z]);
        }
    }
}
